/* BIG STARZ — interaction layer. No dependencies. */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- The Jacket Room ---------- */
  document.querySelectorAll('[data-bs-jr]').forEach(function (root) {
    var slides = [].slice.call(root.querySelectorAll('[data-jr-slide]'));
    var thumbs = [].slice.call(root.querySelectorAll('[data-jr-thumb]'));
    var idx = root.querySelector('[data-jr-i]');
    var rail = root.querySelector('.bs-jr__rail');
    if (!slides.length) return;

    var cur = 0, timer = null, held = false;
    var speed = (parseInt(root.dataset.speed, 10) || 5) * 1000;
    var auto = root.dataset.autoplay === 'true' && !reduce;

    function go(n) {
      cur = (n + slides.length) % slides.length;
      slides.forEach(function (s, i) { s.classList.toggle('is-on', i === cur); });
      thumbs.forEach(function (t, i) {
        var on = i === cur;
        t.classList.toggle('is-on', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      if (idx) idx.textContent = ('0' + (cur + 1)).slice(-2);
      var t = thumbs[cur];
      if (t && rail) {
        var want = t.offsetLeft - (rail.clientWidth / 2) + (t.clientWidth / 2);
        rail.scrollTo({ left: want, behavior: reduce ? 'auto' : 'smooth' });
      }
    }

    function start() { if (auto && !held) { stop(); timer = setInterval(function () { go(cur + 1); }, speed); } }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function hold() { held = true; stop(); }

    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { hold(); go(i); });
      t.addEventListener('mouseenter', function () { if (!reduce) { hold(); go(i); } });
      t.addEventListener('focus', function () { hold(); go(i); });
    });

    var prev = root.querySelector('[data-jr-prev]');
    var next = root.querySelector('[data-jr-next]');
    if (prev) prev.addEventListener('click', function () { hold(); go(cur - 1); });
    if (next) next.addEventListener('click', function () { hold(); go(cur + 1); });

    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { hold(); go(cur + 1); }
      if (e.key === 'ArrowLeft') { hold(); go(cur - 1); }
    });

    /* swipe */
    var x0 = null;
    var stage = root.querySelector('.bs-jr__stage');
    if (stage) {
      stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 45) { hold(); go(cur + (dx < 0 ? 1 : -1)); }
        x0 = null;
      }, { passive: true });
    }

    root.addEventListener('mouseleave', function () { held = false; start(); });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (en) { en.isIntersecting ? start() : stop(); });
      }, { threshold: 0.25 }).observe(root);
    } else { start(); }

    go(0);
  });

  /* ---------- Drop countdown: next Friday 19:00 America/New_York ---------- */
  function nextDrop() {
    var now = new Date();
    var probe = new Date(now.getTime());
    for (var i = 0; i < 15; i++) {
      var d = new Date(probe.getTime() + i * 86400000);
      var et = new Date(d.toLocaleString('en-US', { timeZone: 'America/New_York' }));
      if (et.getDay() === 5) {
        var offset = d.getTime() - et.getTime();
        var etDrop = new Date(et.getFullYear(), et.getMonth(), et.getDate(), 19, 0, 0, 0);
        var target = new Date(etDrop.getTime() + offset);
        if (target > now) return target;
      }
    }
    return null;
  }

  document.querySelectorAll('[data-bs-countdown]').forEach(function (el) {
    var out = el.querySelector('[data-cd-clock]');
    if (!out) return;
    function tick() {
      var t = nextDrop();
      if (!t) { out.textContent = 'LIVE NOW'; return; }
      var s = Math.max(0, Math.floor((t - new Date()) / 1000));
      var d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600),
          m = Math.floor(s % 3600 / 60), sec = s % 60;
      out.innerHTML =
        '<b>' + d + '</b><i>D</i><b>' + ('0' + h).slice(-2) + '</b><i>H</i>' +
        '<b>' + ('0' + m).slice(-2) + '</b><i>M</i><b>' + ('0' + sec).slice(-2) + '</b><i>S</i>';
    }
    tick();
    setInterval(tick, 1000);
  });

  /* ---------- Scroll reveal ----------
     The hidden state is gated on html[data-bs-js], which is stamped ONLY
     here and only when an observer is available. Three failsafes, because
     a section that never reveals is an invisible page:
       1. threshold 0 + a generous rootMargin, so tall sections (the Jacket
          Room, the Halloween portal) fire on their first pixel rather than
          needing 12% of a 4000px block on screen at once.
       2. a 1.5s timer that reveals everything regardless.
       3. reveal-all on pageshow, for bfcache restores.
     Never reintroduce an unconditional `.bs-reveal{opacity:0}` in CSS. */
  function revealAll() {
    document.querySelectorAll('.bs-reveal').forEach(function (s) { s.classList.add('bs-in'); });
  }

  if (!reduce && 'IntersectionObserver' in window) {
    try {
      var sections = [].slice.call(document.querySelectorAll('.shopify-section'));
      if (sections.length) {
        document.documentElement.setAttribute('data-bs-js', '');
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (en) {
            if (en.isIntersecting) { en.target.classList.add('bs-in'); io.unobserve(en.target); }
          });
        }, { threshold: 0, rootMargin: '200px 0px 200px 0px' });
        sections.forEach(function (s, i) {
          if (i === 0) { s.classList.add('bs-in'); return; }
          s.classList.add('bs-reveal');
          io.observe(s);
        });
        setTimeout(revealAll, 1500);
        window.addEventListener('pageshow', revealAll);
      }
    } catch (e) {
      document.documentElement.removeAttribute('data-bs-js');
      revealAll();
    }
  }
})();
